var _rect, _rect2, _text, _text2, _rect3, _text3, _rect4, _text4, _text5, _text6, _text7, _rect5, _text8, _text9, _text0, _text1, _rect6, _text10, _text11, _text12, _rect7, _text13, _text14, _text15, _rect8, _text16, _text17, _text18, _rect9, _text19, _text20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJiraBugAnatomy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 760,
    viewBox: "0 0 1200 760",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 760,
    rx: 36,
    fill: "#F8FBFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 44,
    width: 1092,
    height: 672,
    rx: 28,
    fill: "white",
    stroke: "#DAE5F2",
    strokeWidth: 4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 106,
    fill: "#13213F",
    fontFamily: "Arial, sans-serif",
    fontSize: 38,
    fontWeight: 700
  }, "Anatomy of a Strong JIRA Bug Report")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 145,
    fill: "#56657A",
    fontFamily: "Arial, sans-serif",
    fontSize: 21
  }, "What students should include when logging a professional defect")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 190,
    width: 1028,
    height: 66,
    rx: 18,
    fill: "#173E9F"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 232,
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 28,
    fontWeight: 700
  }, "Summary: Paid PDF download link is not generated after successful payment")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 282,
    width: 490,
    height: 150,
    rx: 22,
    fill: "#EFF5FF",
    stroke: "#BCD0EC",
    strokeWidth: 3
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 328,
    fill: "#173E9F",
    fontFamily: "Arial, sans-serif",
    fontSize: 25,
    fontWeight: 700
  }, "Steps to Reproduce")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 364,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 20
  }, "1. Login as student")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 392,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 20
  }, "2. Open Paid PDFs section")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 420,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 20
  }, "3. Buy API Testing PDF")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 612,
    y: 282,
    width: 502,
    height: 150,
    rx: 22,
    fill: "#FFF5EA",
    stroke: "#F4CA90",
    strokeWidth: 3
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 642,
    y: 328,
    fill: "#C7630A",
    fontFamily: "Arial, sans-serif",
    fontSize: 25,
    fontWeight: 700
  }, "Actual vs Expected")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 642,
    y: 364,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 20
  }, "Actual: Payment success but no link generated")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 642,
    y: 392,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 20
  }, "Expected: Download link should appear after purchase")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 642,
    y: 420,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 20
  }, "Business impact: Student cannot access premium notes")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 458,
    width: 320,
    height: 118,
    rx: 22,
    fill: "#FFF0EE",
    stroke: "#E9B6B0",
    strokeWidth: 3
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 505,
    fill: "#B42318",
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: 700
  }, "Severity &amp; Priority")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 541,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 20
  }, "Severity: Critical")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 568,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 20
  }, "Priority: High")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 458,
    width: 320,
    height: 118,
    rx: 22,
    fill: "#F3FBF6",
    stroke: "#C0E2CF",
    strokeWidth: 3
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 468,
    y: 505,
    fill: "#1A7F52",
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: 700
  }, "Environment")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 468,
    y: 541,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 20
  }, "Chrome, Windows 11")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 468,
    y: 568,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 20
  }, "Build v1.0.0 | qacoder.in")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 790,
    y: 458,
    width: 324,
    height: 118,
    rx: 22,
    fill: "#F7F3FF",
    stroke: "#D9CCF8",
    strokeWidth: 3
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 505,
    fill: "#6E2CF6",
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: 700
  }, "Evidence")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 541,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 20
  }, "Screenshot, screen recording")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 568,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 20
  }, "Console log, API response, test data")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 604,
    width: 1028,
    height: 82,
    rx: 22,
    fill: "#13213F"
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 118,
    y: 652,
    fill: "#E7F0FF",
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: 700
  }, "Strong QA note:")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 288,
    y: 652,
    fill: "#E7F0FF",
    fontFamily: "Arial, sans-serif",
    fontSize: 22
  }, "Clear summary + exact steps + actual/expected + impact + evidence = professional JIRA bug")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraBugAnatomy);
export default __webpack_public_path__ + "static/media/jira-bug-anatomy.9b4b9497015dde525fa99b12a3d5679a.svg";
export { ForwardRef as ReactComponent };